/** Параметр startapp для открытия раздачи в Mini App (см. TelegramGiveawayDeepLink). */
export function telegramStartappParamForGiveaway(giveawayId, shortCode) {
  const sc = String(shortCode ?? "").trim();
  if (sc && /^[a-zA-Z0-9_-]+$/.test(sc)) {
    return `s_${sc}`;
  }
  const id = String(giveawayId ?? "").trim();
  return id ? `g_${id}` : "";
}

function telegramWebAppBotUsername() {
  const fromEnv = String(import.meta.env.VITE_TELEGRAM_WEBAPP_BOT_USERNAME ?? "")
    .trim()
    .replace(/^@/, "");
  return fromEnv || "wicoopbot";
}

function telegramWebAppShortName() {
  return String(import.meta.env.VITE_TELEGRAM_WEBAPP_SHORT_NAME ?? "").trim();
}

/** Ссылка t.me для открытия раздачи в Telegram Mini App. */
export function buildTelegramMiniAppGiveawayShareUrl(giveawayId, shortCode) {
  const startapp = telegramStartappParamForGiveaway(giveawayId, shortCode);
  if (!startapp) return "";

  const username = telegramWebAppBotUsername();
  if (!username) {
    const origin =
      typeof window !== "undefined" && window.location?.origin
        ? window.location.origin
        : "https://tg.wicoop.ru";
    return `${origin.replace(/\/$/, "")}/?startapp=${encodeURIComponent(startapp)}`;
  }

  const shortName = telegramWebAppShortName();
  const base = shortName
    ? `https://t.me/${encodeURIComponent(username)}/${encodeURIComponent(shortName)}`
    : `https://t.me/${encodeURIComponent(username)}`;
  return `${base}?startapp=${encodeURIComponent(startapp)}`;
}

/** Поделиться ссылкой на раздачу (shareUrl в Telegram или копирование). */
export async function shareTelegramGiveawayLink({ giveawayId, shortCode, title }) {
  const url = buildTelegramMiniAppGiveawayShareUrl(giveawayId, shortCode);
  if (!url) return { ok: false, reason: "no_url" };

  const tg = typeof window !== "undefined" ? window.Telegram?.WebApp : null;
  try {
    if (tg && typeof tg.shareUrl === "function") {
      tg.shareUrl(url, String(title || "").trim() || "Раздача Wicoop");
      return { ok: true, method: "shareUrl" };
    }
  } catch {
    /* fallback */
  }

  if (typeof navigator !== "undefined" && navigator.share) {
    try {
      await navigator.share({
        title: title || "Wicoop",
        text: title || "Раздача Wicoop",
        url,
      });
      return { ok: true, method: "navigator" };
    } catch (e) {
      if (e?.name === "AbortError") return { ok: false, reason: "aborted" };
    }
  }

  try {
    await navigator.clipboard.writeText(url);
    return { ok: true, method: "clipboard" };
  } catch {
    window.prompt("Скопируйте ссылку:", url);
    return { ok: true, method: "prompt" };
  }
}
